module.exports = __webpack_public_path__ + "7846c94432e9f2e48b98c464bcce0641.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-princess.png
// module id = 1970
// module chunks = 0